<template>
  <div class="wrapper entry">
    <h2>Results Entry</h2>
    <div class="results-table">
        <h3>Bib: <input v-model="bib"></h3>

        <h3>Start Time</h3>
        <div class="time-entry">
            H:<input v-model="start[0]">
            M:<input v-model="start[1]">
            S:<input v-model="start[2]">
        </div>
        <h3>Finish Time</h3>
        <div class="time-entry">
            H:<input v-model="finish[0]">
            M:<input v-model="finish[1]">
            S:<input v-model="finish[2]">
        </div>
        <button @click="submit()">Submit</button>
        <br/>
        <hr/>
        <h2>TIME: {{ displayTime }}</h2>
    </div>
    <button @click="reset()">Reset</button>
  </div>
</template>

<script>
import { db } from '../../environment.ts';

export default {
  name: 'ResultsEntry',
  firestore() {
    return {
      results: db.collection('results'),
      teams: db.collection('teams')
    }
  },
  data() {
      return {
          bib: '',
          start: [0,0,0], 
          finish: [0,0,0],
          time: 0,
          displayTime: ''
      }
  },
  methods: {
      toSeconds(time) {
          return Number((Number(time[0]) * 3600) + (Number(time[1]) * 60) + Number(time[2]));
      },
      toTime(seconds) {
          return new Date(seconds * 1000).toISOString().substr(11, 8)
      },
      submit() {
          const s = this.toSeconds(this.start);
          const f = this.toSeconds(this.finish);

          this.time = f - s;
          this.displayTime = this.toTime(this.time)
        
          const results = this.$firestore.results.doc(String(this.bib))

          results.get().then((doc) => {
            results.update({ time: this.time })
            this.$firestore.teams
                .doc(doc.data().team)
                .update({ [`memberTimes.${doc.id}`]: this.time })
          })
      },
      reset() {
          this.bib = '';
          this.start = [0,0,0];
          this.finish = [0,0,0],
          this.time = 0,
          this.displayTime = ''
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper.entry {
  padding: 40px;
}
.results-table {
    font-family: sans-serif;
}
.results-table tr {
    text-align: left;
}
.time-entry input {
    width: 50px;
}
.results-table--row td {
    padding-right: 10px;
}
</style>
